// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* File Upload Menu Animation */
.file-upload-menu-enter {
  opacity: 0;
  transform: translateY(10px) scale(0.95);
}

.file-upload-menu-enter-active {
  opacity: 1;
  transform: translateY(0) scale(1);
  transition: opacity 200ms, transform 250ms;
}

.file-upload-menu-exit {
  opacity: 1;
}

.file-upload-menu-exit-active {
  opacity: 0;
  transform: translateY(10px) scale(0.95);
  transition: opacity 200ms, transform 250ms;
}

/* File upload button styles */
.file-upload-button {
  position: relative;
  z-index: 50;
  transition: background-color 0.2s ease-in-out;
}

.file-upload-button:hover {
  background-color: #3a70ff;
}

.file-upload-button:active {
  background-color: #2c65ff;
}

/* File upload menu portal */
.file-upload-portal {
  filter: drop-shadow(0 6px 18px rgba(22, 91, 251, 0.06));
  position: fixed !important;
  z-index: 1000 !important;
  pointer-events: auto !important;
  animation: slight-float 3s ease-in-out infinite;
  transform: translateZ(0); /* Force GPU acceleration */
  backdrop-filter: blur(2px);
}

/* File upload menu triangle pointer */
.file-upload-triangle {
  position: absolute;
  bottom: -8px;
  left: 130px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
  z-index: 1001;
  filter: drop-shadow(0 1px 0 rgba(22, 91, 251, 0.02));
}

.file-upload-triangle-shadow {
  position: absolute;
  bottom: -9px;
  left: 130px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid rgba(22, 91, 251, 0.05);
  z-index: 1000;
}

/* Visual connection line between menu and button */
.file-upload-line {
  opacity: 0.2;
  background: linear-gradient(to bottom, rgba(75, 129, 255, 0.4), transparent);
  animation: pulse-line 3s infinite;
  width: 1.5px !important;
}

@keyframes pulse-line {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.05;
  }
}

/* File Type Option Styles */
.file-type-option {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
}

.file-type-option:hover {
  background-color: rgba(75, 129, 255, 0.08);
  transform: translateX(2px);
}

.file-type-option:active {
  transform: scale(0.98);
}

.file-type-option-icon {
  flex-shrink: 0;
  margin-right: 12px;
}

.file-type-option-details {
  flex-grow: 1;
}

/* File Upload Progress Animation */
@keyframes pulse-upload {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

/* Floating animation for the file upload menu */
@keyframes slight-float {
  0%, 100% {
    transform: translateY(0) translateZ(0);
  }
  50% {
    transform: translateY(-2px) translateZ(0);
  }
}

.upload-progress-pulse {
  animation: pulse-upload 1.5s infinite;
}

.upload-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: white;
  transition: width 0.3s ease-out;
}

/* File Attachment in Messages */
.file-message {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(75, 129, 255, 0.1);
  border-radius: 6px;
  margin-right: 12px;
}

.file-info {
  flex-grow: 1;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
}

.file-size {
  font-size: 12px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/styles/file-upload.css"],"names":[],"mappings":";AACA,+BAA+B;AAC/B;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,uDAAuD;EACvD,0BAA0B;EAC1B,wBAAwB;EACxB,+BAA+B;EAC/B,+CAA+C;EAC/C,wBAAwB,EAAE,2BAA2B;EACrD,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6CAA6C;EAC7C,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,4EAA4E;EAC5E,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["\n/* File Upload Menu Animation */\n.file-upload-menu-enter {\n  opacity: 0;\n  transform: translateY(10px) scale(0.95);\n}\n\n.file-upload-menu-enter-active {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  transition: opacity 200ms, transform 250ms;\n}\n\n.file-upload-menu-exit {\n  opacity: 1;\n}\n\n.file-upload-menu-exit-active {\n  opacity: 0;\n  transform: translateY(10px) scale(0.95);\n  transition: opacity 200ms, transform 250ms;\n}\n\n/* File upload button styles */\n.file-upload-button {\n  position: relative;\n  z-index: 50;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.file-upload-button:hover {\n  background-color: #3a70ff;\n}\n\n.file-upload-button:active {\n  background-color: #2c65ff;\n}\n\n/* File upload menu portal */\n.file-upload-portal {\n  filter: drop-shadow(0 6px 18px rgba(22, 91, 251, 0.06));\n  position: fixed !important;\n  z-index: 1000 !important;\n  pointer-events: auto !important;\n  animation: slight-float 3s ease-in-out infinite;\n  transform: translateZ(0); /* Force GPU acceleration */\n  backdrop-filter: blur(2px);\n}\n\n/* File upload menu triangle pointer */\n.file-upload-triangle {\n  position: absolute;\n  bottom: -8px;\n  left: 130px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid white;\n  z-index: 1001;\n  filter: drop-shadow(0 1px 0 rgba(22, 91, 251, 0.02));\n}\n\n.file-upload-triangle-shadow {\n  position: absolute;\n  bottom: -9px;\n  left: 130px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid rgba(22, 91, 251, 0.05);\n  z-index: 1000;\n}\n\n/* Visual connection line between menu and button */\n.file-upload-line {\n  opacity: 0.2;\n  background: linear-gradient(to bottom, rgba(75, 129, 255, 0.4), transparent);\n  animation: pulse-line 3s infinite;\n  width: 1.5px !important;\n}\n\n@keyframes pulse-line {\n  0%, 100% {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 0.05;\n  }\n}\n\n/* File Type Option Styles */\n.file-type-option {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n}\n\n.file-type-option:hover {\n  background-color: rgba(75, 129, 255, 0.08);\n  transform: translateX(2px);\n}\n\n.file-type-option:active {\n  transform: scale(0.98);\n}\n\n.file-type-option-icon {\n  flex-shrink: 0;\n  margin-right: 12px;\n}\n\n.file-type-option-details {\n  flex-grow: 1;\n}\n\n/* File Upload Progress Animation */\n@keyframes pulse-upload {\n  0% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n/* Floating animation for the file upload menu */\n@keyframes slight-float {\n  0%, 100% {\n    transform: translateY(0) translateZ(0);\n  }\n  50% {\n    transform: translateY(-2px) translateZ(0);\n  }\n}\n\n.upload-progress-pulse {\n  animation: pulse-upload 1.5s infinite;\n}\n\n.upload-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  background-color: white;\n  transition: width 0.3s ease-out;\n}\n\n/* File Attachment in Messages */\n.file-message {\n  display: flex;\n  align-items: center;\n  background: white;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.file-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(75, 129, 255, 0.1);\n  border-radius: 6px;\n  margin-right: 12px;\n}\n\n.file-info {\n  flex-grow: 1;\n}\n\n.file-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.file-size {\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
